import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/alarm_add.svg'


const _hoisted_1 = { class: "alert-banner" }
const _hoisted_2 = ["alt"]
const _hoisted_3 = {
  key: 1,
  class: "alert-banner__copy"
}
const _hoisted_4 = { class: "bold small" }
const _hoisted_5 = {
  key: 0,
  class: "small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MarkdownRenderer = _resolveComponent("MarkdownRenderer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "alert-banner__icon",
      src: _imports_0,
      alt: _ctx.iconAlt
    }, null, 8, _hoisted_2),
    (_ctx.content)
      ? (_openBlock(), _createBlock(_component_MarkdownRenderer, {
          key: 0,
          content: _ctx.content,
          tag: "span",
          class: "small alert-banner__note"
        }, null, 8, ["content"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.title), 1),
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.description), 1))
            : _createCommentVNode("", true)
        ]))
  ]))
}